// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__PuK-v","inputWrap":"CustomTip_inputWrap__3Q413"};